import { h } from "preact";

/**
 * Спиннеры «Лицо/Оборот» + чекбокс «Одинаковые макеты».
 *
 * Пропсы:
 *   face_colors       — число цветов на лице
 *   rear_colors       — число цветов на обороте
 *   same_print        — одинаковые макеты?
 *   oncolorschange    — ({ side, value }) => void
 *   onsameprintcahnge — (value) => void
 */
export function PrintColors({
  face_colors,
  rear_colors,
  same_print,
  oncolorschange,
  onsameprintcahnge,
}) {
  function change(side, delta) {
    const current = side === "face" ? face_colors : rear_colors;
    const min = side === "face" ? 1 : 0;
    const max = 4;
    const next = current + delta;
    if (next < min || next > max) return;
    oncolorschange({ side, value: next });
  }

  function Spinner(title, side, value, min, max) {
    return h("div", { class: "print-colors__side" },
      h("span", { class: "print-colors__label" }, title),
      h("div", { class: "print-colors__spinner" },
        h("button", {
          type: "button",
          class: "print-colors__button",
          disabled: value <= min,
          onClick: () => change(side, -1),
          "aria-label": "Уменьшить",
        }, "−"),
        h("span", { class: "print-colors__value" }, value),
        h("button", {
          type: "button",
          class: "print-colors__button",
          disabled: value >= max,
          onClick: () => change(side, 1),
          "aria-label": "Увеличить",
        }, "+")
      )
    );
  }

  return h("fieldset", { class: "print-colors" },
    h("div", { class: "print-colors__row" },
      Spinner("Лицо", "face", face_colors, 1, 4),
      Spinner("Оборот", "rear", rear_colors, 0, 4)
    ),

    face_colors === rear_colors && h("label", { class: "print-colors__same" },
      h("input", {
        type: "checkbox",
        checked: same_print,
        onchange: () => onsameprintcahnge(!same_print),
        class: "print-colors__same-checkbox",
      }),
      h("span", null, "Одинаковые макеты на обе стороны")
    )
  );
}
